<template>
	<div id="login">
		Login
	</div>
</template>

<script type="">
	export default{
		name:'login'
	}
</script>


// WEBPACK FOOTER //
// src/view/Login.vue